import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { FormattedMessage } from 'react-intl';
import { Pluggable } from '@folio/stripes/core';

const CopyCatRoute = ({ match }) => {
  return (
    <Pluggable
      type="copycat"
      basePath={match.path}
      redirectTo="search"
    >
      <FormattedMessage id="ui-plugin-copycat.copycatPluginNotAvailable" />
    </Pluggable>
  );
};

CopyCatRoute.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
};

export default CopyCatRoute;
